<template>
  <section class="alerts">
    <vue-headful :title="$t('TITLE_TYPE', { type: $tc('ALERT', 2) }) | formatTitle"></vue-headful>
    <alert-list></alert-list>

    <router-view class="alerts__route"></router-view>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import AlertList from './AlertList'

export default {
  name: 'alerts',
  components: { AlertList }
}
</script>
